import { render, staticRenderFns } from "./CustomFieldsTableHeader.vue?vue&type=template&id=27b5ffd0&"
import script from "./CustomFieldsTableHeader.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports